import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://beyerdigital.de';

const unifiedGraph = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      'url': SITE_URL,
      'name': 'beyerdigital',
      'alternateName': ['beyer digital', 'Beyer Digital', 'beyerdigital.de'],
      'description':
        'Digitalagentur für Shopify-Shops, Full-Stack Webentwicklung und KI-Automatisierung in Ludwigsburg und der Region Stuttgart.',
      'publisher': {
        '@id': `${SITE_URL}/#organization`,
      },
      'inLanguage': 'de-DE',
    },
    {
      '@type': 'Person',
      '@id': `${SITE_URL}/#founder`,
      'name': 'Julien Beyer',
      'jobTitle': 'Gründer & Lead Architect',
      'worksFor': {
        '@id': `${SITE_URL}/#organization`,
      },
      'url': `${SITE_URL}/#about`,
      'sameAs': [
        'https://www.linkedin.com/in/julienbeyer',
        'https://github.com/julienbeyer',
      ],
      'knowsAbout': [
        'Shopify 2.0 Theme Development',
        'Headless E-Commerce',
        'Next.js',
        'React',
        'TypeScript',
        'n8n Workflow Automation',
        'Model Context Protocol (MCP)',
        'Conversion Rate Optimization',
      ],
    },
    {
      '@type': ['Organization', 'LocalBusiness', 'ProfessionalService'],
      '@id': `${SITE_URL}/#organization`,
      'name': 'beyerdigital',
      'legalName': 'Julien Beyer — beyerdigital',
      'alternateName': ['beyer digital', 'Beyer Digital', 'beyerdigital.de'],
      'url': SITE_URL,
      'logo': `${SITE_URL}/favicon.png`,
      'image': `${SITE_URL}/og-image.png`,
      'email': 'info@beyerdigital.de',
      'telephone': '+49 176 6414 1449',
      'priceRange': '€€€',
      'currenciesAccepted': 'EUR',
      'paymentAccepted': 'Banküberweisung, Rechnung, Kreditkarte',
      'description':
        'Spezialisierte Digitalagentur für performante Shopify-Shops, moderne Webentwicklung und KI-gestützte Prozessautomatisierung mit Sitz in Ludwigsburg (Region Stuttgart).',
      'founder': {
        '@id': `${SITE_URL}/#founder`,
      },
      'foundingDate': '2024',
      'address': {
        '@type': 'PostalAddress',
        '@id': `${SITE_URL}/#address`,
        'streetAddress': 'Reichenberger Straße 6',
        'addressLocality': 'Ludwigsburg',
        'addressRegion': 'Baden-Württemberg',
        'postalCode': '71638',
        'addressCountry': 'DE',
      },
      'geo': {
        '@type': 'GeoCoordinates',
        '@id': `${SITE_URL}/#geo`,
        'latitude': 48.8906643,
        'longitude': 9.2123135,
      },
      'hasMap': 'https://maps.google.com/?q=Reichenberger+Stra%C3%9Fe+6,+71638+Ludwigsburg',
      'openingHoursSpecification': [
        {
          '@type': 'OpeningHoursSpecification',
          'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          'opens': '09:00',
          'closes': '18:00',
        },
      ],
      'areaServed': [
        { '@type': 'City', 'name': 'Ludwigsburg', 'sameAs': 'https://de.wikipedia.org/wiki/Ludwigsburg' },
        { '@type': 'City', 'name': 'Stuttgart', 'sameAs': 'https://de.wikipedia.org/wiki/Stuttgart' },
        { '@type': 'City', 'name': 'Bietigheim-Bissingen' },
        { '@type': 'City', 'name': 'Kornwestheim' },
        { '@type': 'City', 'name': 'Heilbronn' },
        { '@type': 'City', 'name': 'Esslingen am Neckar' },
        { '@type': 'AdministrativeArea', 'name': 'Region Stuttgart' },
        { '@type': 'AdministrativeArea', 'name': 'Baden-Württemberg', 'sameAs': 'https://de.wikipedia.org/wiki/Baden-W%C3%BCrttemberg' },
        { '@type': 'Country', 'name': 'Deutschland' },
        { '@type': 'Country', 'name': 'Österreich' },
        { '@type': 'Country', 'name': 'Schweiz' },
      ],
      'contactPoint': [
        {
          '@type': 'ContactPoint',
          'telephone': '+49 176 6414 1449',
          'contactType': 'customer service',
          'email': 'info@beyerdigital.de',
          'availableLanguage': ['German', 'English'],
          'areaServed': 'DE',
        },
      ],
      'sameAs': [
        'https://www.linkedin.com/company/beyerdigital',
        'https://github.com/beyerdigital',
        'https://www.instagram.com/beyerdigital',
      ],
      'hasOfferCatalog': {
        '@type': 'OfferCatalog',
        'name': 'Dienstleistungen beyerdigital',
        'itemListElement': [
          {
            '@type': 'OfferCatalog',
            'name': 'E-Commerce & Shopify',
            'itemListElement': [
              {
                '@type': 'Offer',
                'itemOffered': {
                  '@type': 'Service',
                  'name': 'Shopify 2.0 Theme-Entwicklung & Relaunch',
                  'description':
                    'Individuelle, konvertierungsstarke Shopify-Stores für den gehobenen Mittelstand in Ludwigsburg, Stuttgart und DACH.',
                },
              },
              {
                '@type': 'Offer',
                'itemOffered': {
                  '@type': 'Service',
                  'name': 'Headless E-Commerce mit Next.js',
                  'description':
                    'Ultraschnelle, entkoppelte Storefronts mit Next.js und Storefront API für kompromisslose Performance.',
                },
              },
            ],
          },
          {
            '@type': 'OfferCatalog',
            'name': 'KI & Automatisierung',
            'itemListElement': [
              {
                '@type': 'Offer',
                'itemOffered': {
                  '@type': 'Service',
                  'name': 'n8n Workflow-Automatisierung',
                  'description':
                    'Automatisierung von Unternehmensabläufen, CRM-Synchronisation und Belegverarbeitung.',
                },
              },
            ],
          },
        ],
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      'url': SITE_URL,
      'name': 'beyerdigital — Shopify & Webentwicklung Ludwigsburg',
      'description':
        'Ihre Digitalagentur für Ludwigsburg & Stuttgart: Performante Shopify-Shops, moderne Next.js Web-Apps und KI-Automatisierung für den Mittelstand in Baden-Württemberg.',
      'isPartOf': { '@id': `${SITE_URL}/#website` },
      'about': { '@id': `${SITE_URL}/#organization` },
      'inLanguage': 'de-DE',
      'breadcrumb': { '@id': `${SITE_URL}/#breadcrumb` },
    },
    {
      '@type': 'BreadcrumbList',
      '@id': `${SITE_URL}/#breadcrumb`,
      'itemListElement': [
        {
          '@type': 'ListItem',
          'position': 1,
          'name': 'Startseite',
          'item': SITE_URL,
        },
      ],
    },
  ],
};

const SchemaMarkup = () => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(unifiedGraph)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;
